import { fetch_ILS_planDetail_spanish } from "./planDetailSpanish/ILS";

/**
 * all customer specific static info. like
 * customerId, utility functions and some data formatting functions are written here.
 */


export const SHARP_CONSTS = {
  SHARP_ASSETS_PATH: "/sharpNewStyle/",
  HEADER_CALL_NO: "1-855-562-8853",
  COMPARE_PLAN: [1, 2, 3],
  SHARP_CUSTOMER_ID: "HCF0331",
  VANILLA_CUSTOMER_ID: "HCF0999",
  VANILLA_DEMO_CUSTOMER_ID: "HCFLCS6",
  VERDA_CUSTOMER_ID: "HCF0450",
  NEBRASKA_CUSTOMER_ID: "HCF0460",
  ILS_CUSTOMER_ID: "HCF0351",
  //HCF0331
};
export const compareFormatter = (data) => {
  // let dataMap=new Map(Object.entries(data))
  // console.log("arg-",dataMap)
  // console.log("working in if",data)

  let dataObj = {};

  if (data[0]) {
    let keys = Object.keys(data[0]);
    keys.forEach((y) => (dataObj[y] = []));
    keys.forEach((z) => {
      let arr = Object.keys(data[0][z]);
      // console.log("keys-",arr)
      arr.forEach((w) => dataObj[z].push({ key: w }));
    });
    data.forEach((v, index) => {
      keys.forEach((u) => {
        dataObj[u].forEach((t) => {
          let val = `val${index}`;
          // console.log("test-",v[u][t["key"]],val,v[u],t["key"])
          // let k=Object.keys(v).filter((g)=>g.includes(u))[0]
          // let t1=Object.keys(v[k]).filter((l)=>l.includes(t["key"]))[0]
          Object.assign(t, { [val]: v[u][t["key"]] });
        });
      });
    });
  }
  return dataObj;
};
export const VERDA_CONSTS = {
  ID: "HCF0450",
  HEADER_CALL_NO: "1-855-562-8853",
  COMPARE_PLAN: [1, 2, 3],
};
export const NEBRASKA_CONSTS = {
  ID: "HCF0460",
};
export const ILS_CONSTS = {
  ID: "HCF0351",
};
/*
@customerLogo is used to provide the css necessary for showing the customer logo in the header
@contactInfo is used to show customer specific contact ph no. in plan card page
@loginContainer is used to provide  customer specific css to login page container 
@fetchTeleSales is used to show customer specific tele sales pdf file
*/

export const customerLogo = (customerId) => {
  let logo;
  switch (customerId) {
    case VERDA_CONSTS.ID: {
      logo = "wipro-logo verda-logo-white";
      break;
    }
    case NEBRASKA_CONSTS.ID: {
      logo = "wipro-logo braska-logo-white";
      break;
    }
    case ILS_CONSTS.ID: {
      logo = "wipro-logo ils-logo-white";
      break;
    }
    default: {
      logo = "wipro-logo wipro-logo-white";
      break;
    }
  }
  return logo;
};
export const contactInfo = (customerId, loginType) => {
  let contact = { phNum: "", tel: "" };
  switch (customerId) {
    case VERDA_CONSTS.ID: {
      if (loginType === true) {
        contact.phNum = "1-833-319-3801";
        contact.tel = "18333193801";
      } else {
        contact.phNum = "1-888-256-5123";
        contact.tel = "18882565123";
      }
      break;
    }
    case "HCF0331": {
      contact.phNum = "(855) 562-8853";
      contact.tel = "18555628853";
      break;
    }
    case NEBRASKA_CONSTS.ID: {
      contact.phNum = "877-731-2583";
      contact.tel = "18777312583";
      break;
    }
    case ILS_CONSTS.ID: {
      contact.phNum = "1-833-322-7526";
      contact.tel = "18333227526";
      break;
    }
    default: {
      contact.phNum = "(877) 833-3499";
      contact.tel = "18778333499";
      break;
    }
  }
  return contact;
};

export const loginContainer = (customerId) => {
  let loginContainers = "";
  switch (customerId) {
    case NEBRASKA_CONSTS.ID:
    case ILS_CONSTS.ID: {
      loginContainers = "tab-container2 braska-login-container";
      break;
    }
    default: {
      loginContainers = "tab-container2";
      break;
    }
  }
  return loginContainers;
};

export const fetchTeleSales = (customerId) => {
  let telsesales;
  switch (customerId) {
    case NEBRASKA_CONSTS.ID: {
      telsesales = require("../../StaticData/NeBraska/Y0139_NEEnrlmtScript24_C FVNR 0823.pdf");
      break;
    }
    default: {
      telsesales = require("../../StaticData/Wipro Select Medicare Advantage Only 91901.pdf");
      break;
    }
  }
  return telsesales;
};

export const DataValidation = /^[a-zA-Z ]*$/;

/* poArray is to restrict PO BOX related word in permanenr address*/
export const poArray = [
  "P.O ",
  "P.O ",
  "P .O ",
  "PO. ",
  "P O. ",
  "P. O ",
  "P. O. ",
  "P .O. ",
  "P . O ",
  "P.O. ",
  "P .O. ",
  "P O ",
  "PO ",
  "P.O BOX",
  "P.O. BOX",
  "PO BOX",
  "PO-BOX",
  "POBOX",
  "P.O.BOX",
  "PO.BOX",
  "P.OBOX",
];
/*NeBraska_Product_Types is specifically for NEBRASKA SOA tab,*/
export const fetch_NeBraska_Product_Types=(planCardArray)=>{
  let allPlans=[
  {
  planName:"Medicare Prescription Drug Plan (PDP)",
  planNameES:"Medicare Prescription Drug Plan (PDP)",
  productId:"PDP",
  disable:true
},
{
  planName:"Medicare Advantage Plan(s)",
  planNameES:"Medicare Advantage Plan(s)",
  productId:"MAPD",
  disable:true
},
{
  planName:"Ancillary Products",
  planNameES:"Ancillary Products",
  productId:"AUCILLARY",
  disable:true
},
{
  planName:"Medicare Supplement (Medigap)",
  planNameES:"Medicare Supplement (Medigap)",
  productId:"MEDIGAP",
  disable:true
},
]
allPlans.forEach((pln,index)=>{
  if(planCardArray.some((pln1)=>pln1?.productName===pln.productId)){
    allPlans[index]={...allPlans[index],disable:false}
  }
})
return allPlans;
}
export const fetch_customer_language_locales=(customerIds,productIdArray,yearValue)=>{
  /*
  @ this is the wrapper function used to call specfic spanish data based on,
   customerId, productId array and year.
  */
  let details_Locale;
  switch(customerIds){
    case ILS_CONSTS.ID:{
      details_Locale=fetch_ILS_planDetail_spanish(productIdArray,yearValue)
      break;
    }
     default:{
      details_Locale=[]
      break;
    }
  }
  return details_Locale;
}
/* contactInfoSoa is used for pre-enroll SOA TAB only for now*/
export const contactInfoSoa=(customerId)=>{
  let contacts = { phNum: "", tel: "" };
  switch (customerId) {
    case VERDA_CONSTS.ID: {
        contacts.phNum = "1-877-933-6767";
        contacts.tel = "18779336767";
      break;
    }
    case ILS_CONSTS.ID: {
      contacts.phNum = "1-833-322-7526";
      contacts.tel = "18333227526";
      break;
    }
    default: {
      contacts.phNum = "(877) 833-3499";
      contacts.tel = "18778333499";
      break;
    }
  }
  return contacts;
}
